import React from 'react';
import ReactDOM from 'react-dom';
import { store } from './app/store';
import { Provider } from 'react-redux';

function render() {
  const App = require('./app/App').default;
  if (document.getElementById('rootESMBlock')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <App/>
        </Provider>
      </React.StrictMode>,
      document.getElementById('rootESMBlock')
    );
  }
}
function renderIndividualEquipmentBlock() {
  const App = require('./app/AppIndividualEquipment').default;
  if (document.getElementById('rootESMIndividualEquipmentBlock')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <App/>
        </Provider>
      </React.StrictMode>,
      document.getElementById('rootESMIndividualEquipmentBlock')
    );
  }
}
function renderSearchProductCTABlock() {
  const App = require('./app/AppSearchProductCTA').default;
  if (document.getElementById('rootESMSearchProductCTABlock')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <App/>
        </Provider>
      </React.StrictMode>,
      document.getElementById('rootESMSearchProductCTABlock')
    );
  }
}

function renderIconsProfileCartBlock() {
  const App = require('./app/AppIconsProfileCart').default;
  if (document.getElementById('rootESMIconsProfileCartBlock')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <App/>
        </Provider>
      </React.StrictMode>,
      document.getElementById('rootESMIconsProfileCartBlock')
    );
  }
}

function renderRegisterBlock() {
  const App = require('./app/AppRegister').default;
  if (document.getElementById('rootESMRegisterBlock')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <App/>
        </Provider>
      </React.StrictMode>,
      document.getElementById('rootESMRegisterBlock')
    );
  }
}

// function renderNewsBlock() {
//   const App = require('./app/AppNews').default;
//   if (document.getElementById('rootESMNewsBlock')) {
//     ReactDOM.render(
//       <React.StrictMode>
//         <Provider store={store}>
//           <App/>
//         </Provider>
//       </React.StrictMode>,
//       document.getElementById('rootESMNewsBlock')
//     );
//   }
// }

function renderNewsletterBlock() {
  const AppNewsletter = require('./app/AppNewsletter').default;
  if (document.getElementById('rootESMNewsletterBlock')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <AppNewsletter/>
        </Provider>
      </React.StrictMode>,
      document.getElementById('rootESMNewsletterBlock')
    );
  }
}
render();
renderIndividualEquipmentBlock();
renderSearchProductCTABlock();
renderIconsProfileCartBlock();
renderRegisterBlock();
// renderNewsBlock();
renderNewsletterBlock();
